import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
  Routes,
  TitleStrategy,
} from '@angular/router';
import { BlankComponent } from './shared/components/layout/blank/blank.component';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`${title}`);
    }
  }
}

export const titleResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => route.routeConfig?.path?.replace(':guid', 'Payment') ?? '';

export const routes: Routes = [
  {
    path: ':guid',
    title: titleResolver,

    loadComponent: () =>
      import(
        './features/sms-link-legal/feature/sms-link-legal/sms-link-legal.component'
      ).then((m) => m.SmsLinkLegalComponent),
    data: {
      mode: 'sms-link-legal',
      permissions: {
        redirectTo: 'check-permissions',
      },
    },
  },
  {
    path: 'payment-result-success',
    loadComponent: () => {
      return import('./features/payment-result-success/payment-result-success.component').then(
        (m) => m.PaymentResultSuccessComponent
      );
    },
  },
  {
    path: 'payment-result-fail',
    loadComponent: () => {
      return import('./features/payment-result-fail/payment-result-fail.component').then(
        (m) => m.PaymentResultFailComponent
      );
    },
  },
   {
    path: 'payment-result-confirmation-pending',
    loadComponent: () => {
      return import('./features/payment-result-confirmation-pending/payment-result-confirmation-pending.component').then(
        (m) => m.PaymentResultConfirmationPendingComponent
      );
    },
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        title: titleResolver,
        loadChildren: () =>
          import('./auth/feature/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error',
  },
];
